import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import Input from '../../inputs/common/input';
import { FormProps } from '../../../shared/interfaces/form';

interface FormInputProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  handleDurationBlur?: (e: any) => void;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
}

const FormInput = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  handleDurationBlur,
  setValue,
  getValues
}: FormInputProps) => {
  const [ isDisabledInput, setIsDisabledInput ] = React.useState(false);
  
  const handleCustomChange = (e: React.ChangeEvent<HTMLInputElement>, onChange: any) => {
    onChange(e);
    
    if (item.name === 'duration') {
    }
  };

  useEffect(() => {
    const page = window.location.hash.split('/')[1];

    if(page.toLocaleLowerCase().includes('list')) {
      setIsDisabledInput(true);
    }

  }, []);

  return (
    <Controller
    key={`input-${index}-${baseId}`}
      name={item.name}
      control={control}
      defaultValue={item.value || ''}
      rules={item.rules}
      render={({ field }) => (
        <div className={`form-input-wrapper ${item.fullWidth ? 'full-width' : ''}`}>
          <Input 
            type={item.type} 
            placeholder={item.placeholder} 
            error={errors[item.name]?.message}
            width="100%"
            height={item.height}
            disabled={item.disabled || isDisabledInput}
            value={field.value}
            onChange={(e) => handleCustomChange(e, field.onChange)}
            onBlur={item.name === "duration" ? handleDurationBlur : field.onBlur}
            name={field.name}
            mask={item.mask}
          />
        </div>
      )}
    />
  );
};

export default FormInput;